import React, { useEffect, useState } from "react";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import {
  ContentModalActiveSurvey,
  CloseModalActiveSurvey,
  ButtonActiveSurvey,
  ButtonActiveSurveyCancel,
  ContentModal,
  ActionButtons,
  ModalTitle,
  PreviewPanel,
} from "./ModalTemplatePreview.styled";
import { useMutation } from "@apollo/client";
import { ENCRIPT_PARAMETERS } from "../../GraphQL/Mutations";
import ModalLoader from "../ModalLoader/ModalLoader";
import FillOutSurveyContainer from "../../containers/FillOutSurveyContainer";
import { NotificationManager } from "react-notifications";

const ModalTemplatePreview = ({
  setModalVisibility,
  template,
  handleApplyTemplate,
}) => {
  const [encriptParameters, { loading: loadingSurvey }] =
    useMutation(ENCRIPT_PARAMETERS);
  const [param, setParam] = useState("");

  useEffect(() => {
    if (template?.surveyId) {
      setParam("");
      encriptParameters({
        variables: {
          idSurvey: template?.surveyId.toString(),
        },
      })
        .then((value) => {
          setParam(value?.data?.encriptParameters);
        })
        .catch((error) => {
          const errorMessage = error.message.split("\n")[0];
          NotificationManager.error(errorMessage, "", 5000);
        });
    }
  }, [template]);

  return (
    <>
      <ContentModal>
        <ContentModalActiveSurvey>
          <CloseModalActiveSurvey>
            <ModalTitle>{template?.description}</ModalTitle>
            <Tooltip title="close">
              <IconButton onClick={() => setModalVisibility(false)}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </CloseModalActiveSurvey>
          <PreviewPanel>
            {param && (
              <FillOutSurveyContainer paramProp={param} previewProp={true} />
            )}
            {!template && (
              <p style={{ textAlign: "center" }}>
                Please choose a template to preview
              </p>
            )}
          </PreviewPanel>
          <ActionButtons>
            <ButtonActiveSurvey
              onClick={() => {
                handleApplyTemplate(template);
                setModalVisibility(false);
              }}
            >
              Use
            </ButtonActiveSurvey>
            <ButtonActiveSurveyCancel onClick={() => setModalVisibility(false)}>
              Cancel
            </ButtonActiveSurveyCancel>
          </ActionButtons>
        </ContentModalActiveSurvey>
      </ContentModal>
      {loadingSurvey && <ModalLoader />}
    </>
  );
};

export default ModalTemplatePreview;
